<img [src]="BaseUrl + ImgName" width="800" height="600">
